import OverviewConfig from './overview/OverviewConfig';
import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import enGB from '@locales/inventurius/enGB';
import deAT from '@locales/inventurius/deAT';

i18next.addResourceBundle('enGB', 'inventurius', enGB);
i18next.addResourceBundle('deAT', 'inventurius', deAT);

const InventuriusConfigs = [
	OverviewConfig,
	{
		routes: [
			{
				path: '/iv',
				exact: true,
				element: <Navigate to="/iv/overview" />,
			}
		]
	}
];

export default InventuriusConfigs;
